import type { JSX } from 'react';

import styles from './AuditPage.module.scss';
import { AuditLogViewer } from '../components/AuditLogViewer';

/** OS-1726 — `/audit`: acciones administrativas registradas en la plataforma. */
export function AuditPage(): JSX.Element {
  return (
    <div className={styles.page}>
      <div>
        <h1 className={styles.title}>Auditoría</h1>
        <p className={styles.muted}>
          Acciones registradas por los administradores de plataforma y bloqueos del sistema. El
          registro no se puede editar ni borrar; los datos personales y credenciales se muestran
          ocultos.
        </p>
      </div>
      <AuditLogViewer />
    </div>
  );
}
